import { render, staticRenderFns } from "./otpInputNew.vue?vue&type=template&id=71cda55a&"
import script from "./otpInputNew.vue?vue&type=script&lang=js&"
export * from "./otpInputNew.vue?vue&type=script&lang=js&"
import style0 from "./otpInputNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports